// Edit branch details here. Add, remove, or update branches as needed —
// both the "Our Branches" section and the Enquiry page pull from this file.
//
// IMPORTANT: Replace the "gst" placeholder values below with your real GSTIN
// for each branch. These are shown to visitors only after they submit an enquiry.

const branchesData = [
  {
    id: 1,
    name: 'Janakpuri Branch',
    address: 'G-16, Ground Floor, Kirti Shikhar Building, Plot No. 11, Distt Centre, Janakpuri, New Delhi - 110058',
    phone: '+91 93504-96575',
    email: 'ks@infotechks.com',
    gst: '06KZLPK2551L1ZU',
  },
  {
    id: 2,
    name: 'Bangalore Branch',
    address: 'First Floor, Meenukunte Hosur Village Doddajala Post, Jala Hobli, Yelahanka Taluk Bangalore, India-562157',
    phone: '+91 93504-96575',
    email: 'ks@infotechks.com',
    gst: '06KZLPK2551L1ZU',
  },
];

export default branchesData;
